export default `
  mutation getAttachmentUploadUrl($projectId: String!, $workflowId: String!, $cardId: String!, $filename: String!) {
    getAttachmentUploadUrl(projectId: $projectId, workflowId: $workflowId, cardId: $cardId, filename: $filename) {
      url
      key
      bucket
      region
    }
  }
`
